import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let resultRequest;

    if (sessionStorage.getItem('token')) {
      resultRequest = req.clone({
        setHeaders: {
          Authorization: sessionStorage.getItem('token')
        }
      });
    } else {
      resultRequest = req;
    }

    return next.handle(resultRequest);
  }
}
